import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Affiliate Users
export const affiliateUsersList = (params = {}) => Http.get('/affiliate-users', { params })
export const affiliateUserByID = (id) => Http.get(`/affiliate-users/${id}`)

// Per-user affiliate data (used in detail view)
export const affiliateDocumentsForUser = (params = {}) => Http.get('/affiliate-documents', { params })
export const affiliateCommissionsForUser = (params = {}) => Http.get('/affiliate-commissions', { params })
export const affiliateRequestsForUser = (params = {}) => Http.get('/affiliate-commissions/payment-requests', { params })
export const affiliatePaymentMethodsForUser = (params = {}) => Http.get('/affiliate-payment-methods', { params })

// // COMMISSIONS
// // // LIST ALL COMMISSIONS
export const commissionsList = (params = '') => Http.get(`/affiliate-commissions${serialize(params)}`)
export const commissionsByID = (params = '') => Http.get(`/affiliate-commissions/${params}`)
export const newCommission = (params = '') => Http.post('/affiliate-commissions', params)
export const updateCommissions = (params = '') => Http.put(`/affiliate-commissions/${params.id}`, params)
export const deleteCommissionByID = (params = '') => Http.delete(`/affiliate-commissions/${params.id}`)

//Documents
export const documentCreate = (params = '') => Http.post('/affiliate-documents', params)
export const documentsList = (params = {}) =>
	Http.get('/affiliate-documents', {
		params: {
			include: 'user.affiliate_payment_methods',
			...params,
		},
	})
export const documentByID = (params = '') => Http.get(`/affiliate-documents/${params}`)
export const documentUpdate = (params = '') => Http.put(`/affiliate-documents/${params.id}`, params)
export const documentDestroy = (params = '') => Http.delete(`/affiliate-documents/${params.id}`)

//Requests
export const requestCreate = (params = '') => Http.post('/affiliate-commissions/payment-requests', params)
export const requestsList = (params = '') => Http.get(`/affiliate-commissions/payment-requests${serialize(params)}`)
export const requestByID = (params = '') => Http.get(`/financial-institution-requests/${params}`)
export const requestUpdate = (params = '') => Http.put(`/affiliate-commissions/payment-requests/${params.id}`, params)
export const requestDestroy = (params = '') => Http.delete(`/affiliate-commissions/payment-requests/${params.id}`)
